import React from 'react';
import {useTranslation} from 'react-i18next';
import {Helmet} from 'react-helmet-async';
import SEO from './SEO';
import ProfileSidebar from './Person_components/ProfileSidebar'; // 导入新创建的组件
import Home from './Person_components/Home';
import ProfessionalServices from './Person_components/ProfessionalServices';
import SelectedPublications from './Person_components/SelectedPublications';
import heroBackgroundImage from '../assets/images/hero_background/about_hero_bg_original4.jpg';
import {Tab, TabGroup, TabList, TabPanel, TabPanels} from '@headlessui/react'

const Person = () => {
  const {t, i18n} = useTranslation(['people', 'common', 'title']);
  const isChinese = i18n.language.includes('zh');

  return (
    <div className="bg-white">
      <SEO title="Yi Zeng"></SEO>
      <div className="bg-cover bg-white bg-blend-hard-light bg-bottom bg-no-repeat min-h-[75px] sm:min-h-[75px] w-full flex flex-col justify-start items-center p-6"
           style={{backgroundImage: `url(${heroBackgroundImage})`}}
      >
{/*        <div className="flex flex-col justify-center items-start max-w-[900px] mt-36 mb-16">
          <div className={`font-bold tracking-[.02em] text-white leading-normal ${isChinese ? 'text-4xl sm:text-[3.5rem] sm:tracking-[.05em]' : 'text-4xl sm:text-[3rem] sm:tracking-[.02em]'}`}>
            {t('hero_heading_1')}
          </div>
        </div>*/}
      </div>

      <div className="content-container pt-8 pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <nav className="flex mb-7 ml-2" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
              <li className="inline-flex items-center">
                <a href="/" className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-[#c00000]">
                  <svg className="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"/>
                  </svg>
                  Home
                </a>
              </li>
              <li>
                <div className="flex items-center">
                  <svg className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
                  </svg>
                  <a href="/people" className="ms-1 text-sm font-medium text-gray-700 hover:text-[#c00000] md:ms-2">Leaders and Scientists</a>
                </div>
              </li>
              <li aria-current="page">
                <div className="flex items-center">
                  <svg className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
                  </svg>
                  <span className="ms-1 text-sm font-medium text-gray-500 md:ms-2">Yi Zeng</span>
                </div>
              </li>
            </ol>
          </nav>

          <div className="flex flex-col md:flex-row gap-8">
            {/* 左侧个人信息栏 */}
            <div className="w-full md:w-1/3 lg:w-1/4">

            {/*<nav class="flex px-5 py-3 mb-4 text-gray-700 border border-gray-200 rounded-lg bg-gray-50" aria-label="Breadcrumb">
              <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                <li class="inline-flex items-center">
                  <a href="#" class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600">
                    <svg class="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                      <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"/>
                    </svg>
                    Home
                  </a>
                </li>
                <li>
                  <div class="flex items-center">
                    <svg class="rtl:rotate-180 block w-3 h-3 mx-1 text-gray-400 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
                    </svg>
                    <a href="#" class="ms-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ms-2">Templates</a>
                  </div>
                </li>
                <li aria-current="page">
                  <div class="flex items-center">
                    <svg class="rtl:rotate-180  w-3 h-3 mx-1 text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
                    </svg>
                    <span class="ms-1 text-sm font-medium text-gray-500 md:ms-2">Flowbite</span>
                  </div>
                </li>
              </ol>
            </nav>*/}

              <ProfileSidebar/>
            </div>

            {/* 右侧内容区域 */}
            <div className="w-full md:w-2/3 lg:w-3/4">
              <TabGroup>
                <TabList className="flex p-1 space-x-1 bg-gray-100 rounded-xl">
                  <Tab
                    key={"Home"}
                    className={({selected}) =>
                      `w-full rounded-lg py-2.5 text-sm font-medium leading-5
                        ${selected
                        ? 'bg-white shadow text-[#c00000]'
                        : 'text-gray-500 hover:bg-white/[0.12] hover:text-gray-700'} 
                                ring-white ring-opacity-60 ring-offset-2 ring-offset-[#c00000] focus:outline-none focus:ring-2 transition-all duration-200`
                    }
                  >
                    Home
                  </Tab>
                  <Tab
                    className={({selected}) =>
                      `w-full rounded-lg py-2.5 text-sm font-medium leading-5
                        ${selected
                        ? 'bg-white shadow text-[#c00000]'
                        : 'text-gray-500 hover:bg-white/[0.12] hover:text-gray-700'} 
                                ring-white ring-opacity-60 ring-offset-2 ring-offset-[#c00000] focus:outline-none focus:ring-2 transition-all duration-200`
                    }
                  >
                    Selected Publications
                  </Tab>
                  <Tab
                    className={({selected}) =>
                      `w-full rounded-lg py-2.5 text-sm font-medium leading-5
                        ${selected
                        ? 'bg-white shadow text-[#c00000]'
                        : 'text-gray-500 hover:bg-white/[0.12] hover:text-gray-700'} 
                                ring-white ring-opacity-60 ring-offset-2 ring-offset-[#c00000] focus:outline-none focus:ring-2 transition-all duration-200`
                    }
                  >
                    Professional Services
                  </Tab>
                </TabList>
                <TabPanels className="mt-4">
                  <TabPanel className="bg-white rounded-xl shadow-lg p-4 ring-1 ring-gray-200">
                    <Home/>
                  </TabPanel>
                  <TabPanel className="bg-white rounded-xl shadow-lg p-4 ring-1 ring-gray-200">
                    <SelectedPublications/>
                  </TabPanel>
                  <TabPanel className="bg-white rounded-xl shadow-lg p-4 ring-1 ring-gray-200">
                    <ProfessionalServices/>
                  </TabPanel>
                </TabPanels>
              </TabGroup>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Person;